module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Lumenas Photography","short_name":"Lumenas","start_url":"/","lang":"de","icon":"src/images/lumenas-favicon.png","description":"Street Photography aus Berlin und anderen Städten Europas sowie analoge Fotografie mit der Lochkamera und in historischen Verfahren der Fotografie","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"91cd5d937d59ea2074a292fecc9d9f0b"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
